import axios from 'axios'
import store from '../../store'
import util from "../../utils/util";
const AXIOS = axios.create({
  baseURL: '/api',

timeout: 50000
})



export default {
  /** User methods **/
  getUsers() {
    const url = '/user';
    return AXIOS.get(url).then(response => response.data);
  },

  getUser (userId) {
    const url = "/user/";
    return AXIOS.get(url+ userId).then(response => response.data);
  },
  getCurrentUser() {
    const url = "/user/current/myProfile";
    return AXIOS.get(url).then(response => response.data);
  },
  createUser (firstName, lastName, email, username,password, role, department) {
    if (typeof department !='object') {
      department = {'name':department, 'id':department}
    }
    return AXIOS.post('/user/' ,
      {
        firstName: firstName,
        lastName: lastName,
        role:role,
        email: email,
        username: username,
        password:password,
        locale: store.state.curLanguage,
        department: department
      }
      ).then(response=>response.data)
  },
  editUser (id,firstName, lastName, email, username, password, role, department) {
    if (typeof department !='object') {
      department = {'name':department, 'id':department}
    }
    return AXIOS.patch('/user/' ,
      {
        id: id,
        firstName: firstName,
        lastName: lastName,
        role:role,
        email: email,
        username: username,
        password:password,
        department:department
      }
    ).then(response=>response.data)
  },
  deleteUser (id) {
    return AXIOS.delete('/user/' ,
      {
        data: {
          id: id}
      }
    ).then(response=>response.data)
  },



  /** Project methods **/
  getProjects(includeInactive) {
    const url = '/project?includeInactive=' + includeInactive;
    return AXIOS.get(url).then(response => response.data);
  },
  getProject (projectId) {
    const url = "/project/";
    return AXIOS.get(url+ projectId).then(response => response.data);
  },
  createProject (projectName, projectNumber,  projectType, language, department, templateProjectId) {
    if (typeof projectType !='object') {
      projectType = {'name':projectType, 'id':0}
    }
    if (typeof department !='object') {
      department = {'name':department, 'id':department}
    }

     return AXIOS.post('/project/' ,
      {
        name: projectName,
        projectType: projectType,
        language:language,
        projectNumber:projectNumber,
        department:department,
        templateProjectId:templateProjectId
        }
    ).then(response=>response.data)
  },
  editProject (id, projectName, projectNumber, projectType, language, department) {
    if (typeof projectType !='object') {
      projectType = {'name':projectType, 'id':0}
    }
    if (typeof department !='object') {
      department = {'name':department, 'id':department}
    }
    return AXIOS.patch('/project/' ,
      {
        id: id,
        name: projectName,
        projectType: projectType,
        language:language,
        projectNumber:projectNumber,
        department:department
      }
    ).then(response=>response.data)
  },
  deleteProject(projectId) {
   return AXIOS.delete('/project/' ,
      {
        data : {
          id: projectId
        }
      }
    ).then(response=>response.data)
  },
  switchActiveStatusOnProject(projectId) {
    const url = "/project/switchActiveStatus/";
    return AXIOS.get(url+ projectId).then(response => response.data);

  },


  getProjectLanguages () {
    const url = '/language/project';
    return AXIOS.get(url).then(response => response.data);


  },

  /** WorkType methods **/
  getWorkTypes() {
    const url = '/workType';
    return AXIOS.get(url).then(response => response.data);
  },
  getWorkTypesForProject(projectId) {
    const url = "/workType/project/"
    return AXIOS.get(url + projectId).then(response => response.data);
  },
  getWorkType (workTypeId) {
    const url = "/workType/";
    return AXIOS.get(url+ workTypeId).then(response => response.data);
  },
  createWorkType (workTypeName) {

    return AXIOS.post('/workType/' ,
      {
        name: workTypeName

      }
    ).then(response=>response.data)
  },

  editWorkType (id, workTypeName) {

    return AXIOS.patch('/workType/' ,
      {
        id: id,
        name: workTypeName

      }
    ).then(response=>response.data)
  },
  deleteWorkType (id) {
    return AXIOS.delete('/workType/' ,
      {
        data: {
          id: id}
      }
    ).then(response=>response.data)
  },

  /** WorkOperation methods **/
  getWorkOperations(workTypeId) {
    const url = '/workOperation/workType/';
    return AXIOS.get(url + workTypeId).then(response => response.data);
  },
  getWorkOperation (workOperationId) {
    const url = "/workOperation/";
    return AXIOS.get(url+ workOperationId).then(response => response.data);
  },
  createWorkOperation (workTypeId, workOperationName) {
    return AXIOS.post('/workOperation/' ,
      {
        workTypeId: workTypeId,
        name: workOperationName

      }
    ).then(response=>response.data)
  },

  editWorkOperation (id, workOperationName) {

    return AXIOS.patch('/workOperation/' ,
      {
        id: id,
        name: workOperationName

      }
    ).then(response=>response.data)
  },

deleteWorkOperation (id) {
  return AXIOS.delete('/workOperation/' ,
    {
      data: {
        id: id}
    }
  ).then(response=>response.data)
},


  /** IncidentTypes methods      */
  getIncidentTypes () {
    const url = '/incidentType';
    return AXIOS.get(url).then(response => response.data);
  },
  getIncidentType (id) {
    const url = "/incidentType/";
    return AXIOS.get(url+ id).then(response => response.data);
  },
  createIncidentType (name) {
    return AXIOS.post('/incidentType/' ,
      {
        name: name
      }
    ).then(response=>response.data)
  },
  editIncidentType (id, name) {
    return AXIOS.patch('/incidentType/' ,
      {
        id: id,
        name: name
      }
    ).then(response=>response.data)
  },
  deleteIncidentType (id) {
    return AXIOS.delete('/incidentType/' ,
      {
        data: {
        id: id}
       }
    ).then(response=>response.data)
  },
  /** MeasureResponsible methods      */
  getMeasureResponsibles () {
    const url = '/measureResponsible';
    return AXIOS.get(url).then(response => response.data);
  },
  getMeasureResponsible (id) {
    const url = "/measureResponsible/";
    return AXIOS.get(url+ id).then(response => response.data);
  },
  createMeasureResponsible (name) {
    return AXIOS.post('/measureResponsible/' ,
      {
        name: name
      }
    ).then(response=>response.data)
  },
  editMeasureResponsible (id, name) {
    return AXIOS.patch('/measureResponsible/' ,
      {
        id: id,
        name: name
      }
    ).then(response=>response.data)
  },
  deleteMeasureResponsible (id) {
    return AXIOS.delete('/measureResponsible/' ,
      {
        data: {
          id: id}
      }
    ).then(response=>response.data)
  },

  /** BarrierOwner methods      */
  getBarrierOwners () {
    const url = '/barrierOwner';
    return AXIOS.get(url).then(response => response.data);
  },
  getBarrierOwner (id) {
    const url = "/barrierOwner/";
    return AXIOS.get(url+ id).then(response => response.data);
  },
  createBarrierOwner (name) {
    return AXIOS.post('/barrierOwner/' ,
      {
        name: name
      }
    ).then(response=>response.data)
  },
  editBarrierOwner (id, name) {
    return AXIOS.patch('/barrierOwner/' ,
      {
        id: id,
        name: name
      }
    ).then(response=>response.data)
  },
  deleteBarrierOwner (id) {
    return AXIOS.delete('/barrierOwner/' ,
      {
        data: {
          id: id}
      }
    ).then(response=>response.data)
  },

  /** Location methods      */
  getLocations () {
    const url = '/location';
    return AXIOS.get(url).then(response => response.data);
  },
  getLocation (id) {
    const url = "/location/";
    return AXIOS.get(url+ id).then(response => response.data);
  },
  createLocation (name) {
    return AXIOS.post('/location/' ,
      {
        name: name
      }
    ).then(response=>response.data)
  },
  editLocation (id, name) {
    return AXIOS.patch('/location/' ,
      {
        id: id,
        name: name
      }
    ).then(response=>response.data)
  },
  deleteLocation (id) {
    return AXIOS.delete('/location/' ,
      {
        data: {
          id: id}
      }
    ).then(response=>response.data)
  },


  /** Department methods      */
  getDepartments () {
    const url = '/department';
    return AXIOS.get(url).then(response => response.data);
  },
  getDepartment (id) {
    const url = "/department/";
    return AXIOS.get(url+ id).then(response => response.data);
  },
  createDepartment (name) {
    return AXIOS.post('/department/' ,
      {
        name: name
      }
    ).then(response=>response.data)
  },
  editDepartment (id, name) {
    return AXIOS.patch('/department/' ,
      {
        id: id,
        name: name
      }
    ).then(response=>response.data)
  },
  deleteDepartment (id) {
    return AXIOS.delete('/department/' ,
      {
        data: {
          id: id}
      }
    ).then(response=>response.data)
  },


  /** ProjectTypes methods      */
  getProjectTypes () {
    const url = '/projectType';
    return AXIOS.get(url).then(response => response.data);
  },
  getProjectType (id) {
    const url = "/projectType/";
    return AXIOS.get(url+ id).then(response => response.data);
  },
  createProjectType (name, workTypeIds, workTypeNames) {
    return AXIOS.post('/projectType/' ,
      {
        name: name,
        workTypeIds: workTypeIds,
        workTypeNames: workTypeNames
      }
    ).then(response=>response.data)
  },
  editProjectType (id, name, workTypeIds, workTypeNames) {
      return AXIOS.patch('/projectType/' ,
      {
        id: id,
        name: name,
        workTypeIds: workTypeIds,
        workTypeNames: workTypeNames
      }
    ).then(response=>response.data)
  },
  deleteProjectType (id) {
    return AXIOS.delete('/projectType/' ,
      {
        data: {
          id: id}
      }
    ).then(response=>response.data)
  },






  /** ConsequenceTypes methods      */
  getConsequenceTypes () {
    const url = '/consequenceType';
    return AXIOS.get(url).then(response => response.data);
  },
  getConsequenceType (id) {
    const url = "/consequenceType/";
    return AXIOS.get(url+ id).then(response => response.data);
  },
  createConsequenceType (name) {
    return AXIOS.post('/consequenceType/' ,
      {
        name: name,
      }
    ).then(response=>response.data)
  },
  editConsequenceType (id, name) {
    return AXIOS.patch('/consequenceType/' ,
      {
        id: id,
        name: name,
      }
    ).then(response=>response.data)
  },
  deleteConsequenceType (id) {
    return AXIOS.delete('/consequenceType/' ,
      {
        data: {
          id: id}
      }
    ).then(response=>response.data)
  },

  /** Consequence Strengths **/
  getConsequenceStrengths () {
    const url = '/consequenceStrength';
    return AXIOS.get(url).then(response => response.data);
  },
  editConsequenceStrengths (consequenceStrengths) {

    return AXIOS.patch('/consequenceStrength/' ,
      {
        consequenceStrengths:  consequenceStrengths,
      }
    ).then(response=>response.data)
  },

  /** Consequence Strengths **/
  getProbabilityLevels () {
    const url = '/probabilityLevel';
    return AXIOS.get(url).then(response => response.data);
  },
  editProbabilityLevels (probabilityLevels) {

    return AXIOS.patch('/probabilityLevel/' ,
      {
        probabilityLevels:  probabilityLevels,
      }
    ).then(response=>response.data)
  },

  /** PotentialIncident methods **/
  getPotentialIncidents(projectId) {
    const url = "/potentialIncident/project/";
    return AXIOS.get(url + projectId).then(response => response.data);
  },

  getPotentialIncident(id) {
    const url = "/potentialIncident/";
    return AXIOS.get(url + id).then(response => response.data);
  },

  deletePotentialIncident(id) {
    return AXIOS.delete('/potentialIncident/' ,
      {
        data : {
          id: id
        }
      }
    ).then(response=>response.data)

  },
  copyIncidentsToProject(fromProjectId, toProjectId, ids) {
    return AXIOS.post('/potentialIncident/copyToProject/' ,
      {
          fromProjectId:fromProjectId,
          toProjectId: toProjectId,
          ids:ids
      }
    ).then(response=>response.data)
  },

  deletePotentialIncidents(ids) {
    return AXIOS.delete('/potentialIncident/deleteMultiple/' ,
      {
        data : {
          ids:ids
        }
      }
    ).then(response=>response.data)

  },

  createPotentialIncident(projectId, workType, workOperation, location, incidentType, consequenceType, consequence, consequenceAfterMeasures, probabilityAfterMeasures, barriers, measures, explanation) {

    if (typeof consequenceType != 'object') {
      consequenceType = {'name':'', 'id':consequenceType}
    }

    if (typeof workType != 'object') {
      workType = {'name':workType, 'id':0}
    }
    if (typeof workOperation != 'object') {
      workOperation = {'name':workOperation, 'id':0}
    }
    if (typeof location != 'object') {
      location = {'name':location, 'id':0}
    }
    if (typeof incidentType != 'object') {
      incidentType = {'name':incidentType, 'id':0}
    }
    if (typeof consequence != 'object') {
      consequence = {'name': consequence.toString(), 'id': parseInt(consequence)}
    }
    if (typeof consequenceAfterMeasures != 'object') {
      consequenceAfterMeasures = {'name': consequenceAfterMeasures.toString(), 'id': parseInt(consequenceAfterMeasures)}
    }

    if (typeof probabilityAfterMeasures != 'object') {
      probabilityAfterMeasures = {'name': probabilityAfterMeasures.toString(), 'id': parseInt(probabilityAfterMeasures)}
    }

     barriers = barriers.map(barrier=>{
     var barrierOwner = barrier.owner
     if (typeof barrierOwner != 'object') {
       barrierOwner = {'name':barrierOwner, 'id':0}
     }

     return {"description": barrier.description, "strength": barrier.strength, "comment": barrier.comment,
              "type":barrier.type, "owner":barrierOwner}})


    measures = measures.map(measure=>{
      var measureResponsible = measure.measureResponsible
      if (typeof measureResponsible != 'object') {
        measureResponsible = {'name':measureResponsible, 'id':0}
      }

      return {"measure": measure.measure, "status": measure.status, "commentOnClosed": measure.commentOnClosed,
        "dateClosed":measure.dateClosed, "measureResponsible":measureResponsible}})


     return AXIOS.post('/potentialIncident/',
      {
        projectId: projectId,
        workType: workType,
        workOperation: workOperation,
        incidentType: incidentType,
        location:location,
        consequenceType: consequenceType,
        consequence: consequence,
        measures: measures,
        consequenceAfterMeasures: consequenceAfterMeasures,
        probabilityAfterMeasures: probabilityAfterMeasures,
        explanation: explanation,
        barriers: barriers

      }
    ).then(response => response.data);
  },

  editPotentialIncident(id, workType, workOperation, location, incidentType, consequenceType,consequence,  probabilityAfterMeasures, consequenceAfterMeasures, barriers, measures, explanation) {

    if (typeof consequenceType != 'object') {
      consequenceType = {'name':'', 'id':consequenceType}
    }
     if (typeof workType != 'object') {
      workType = {'name':workType, 'id':0}
    }
    if (typeof workOperation != 'object') {
      workOperation = {'name':workOperation, 'id':0}
    }
    if (typeof incidentType != 'object') {
      incidentType = {'name':incidentType, 'id':0}
    }
    if (typeof location != 'object') {
      location = {'name':location, 'id':0}
    }
    if (typeof consequence != 'object') {
      consequence = {'name': consequence.toString(), 'id': parseInt(consequence)}
    }
    if (typeof consequenceAfterMeasures != 'object') {
      consequenceAfterMeasures = {'name': consequenceAfterMeasures.toString(), 'id': parseInt(consequenceAfterMeasures)}
    }
    if (typeof probabilityAfterMeasures != 'object') {
      probabilityAfterMeasures = {'name': probabilityAfterMeasures.toString(), 'id': parseInt(probabilityAfterMeasures)}
    }

    barriers = barriers.map(barrier=>{
      var barrierOwner = barrier.owner
      if (barrierOwner==null || typeof barrierOwner != 'object') {
        barrierOwner = {'name':barrierOwner, 'id':0}
      }
      return {"description": barrier.description, "strength": barrier.strength, "comment": barrier.comment,
        "type":barrier.type, "owner":barrierOwner}})

    measures = measures.map(measure=>{
      var measureResponsible = measure.measureResponsible
      if (measureResponsible==null || typeof measureResponsible != 'object') {
        measureResponsible = {'name':measureResponsible, 'id':0}
      }

      return {"measure": measure.measure, "status": measure.status, "commentOnClosed": measure.commentOnClosed,
        "dateClosed":measure.dateClosed, "measureResponsible":measureResponsible}})


    return AXIOS.patch('/potentialIncident/',
      {
        id: id,
        workType: workType,
        workOperation:workOperation,
        location:location,
        incidentType: incidentType,
        consequenceType: consequenceType,
        consequence: consequence,
        consequenceAfterMeasures: consequenceAfterMeasures,
        probabilityAfterMeasures: probabilityAfterMeasures,
        explanation: explanation,
        measures: measures,
         barriers: barriers

      }
    ).then(response => response.data);
  },


  calculateProbability(projectId, workType, workOperation, location, incidentType, consequenceType, consequence,  consequenceAfterMeasures, barriers, measures) {

    if (typeof workType != 'object') {
      workType = {'name':workType, 'id':0}
    }
    if (typeof consequenceType != 'object') {
      consequenceType = {'name':consequenceType, 'id':0}
    }
    if (typeof workOperation != 'object') {
      workOperation = {'name':workOperation, 'id':0}
    }
    if (typeof incidentType != 'object') {
      incidentType = {'name':incidentType, 'id':0}
    }
    if (typeof location != 'object') {
      location = {'name':location, 'id':0}
    }
    if (typeof consequence != 'object') {
      consequence = {'name': consequence.toString(), 'id': parseInt(consequence)}
    }
    if (typeof consequenceAfterMeasures != 'object') {
      consequenceAfterMeasures = {'name': consequenceAfterMeasures.toString(), 'id': parseInt(consequenceAfterMeasures)}
    }

    barriers = barriers.map(barrier=>{
      var barrierOwner = barrier.owner
      if (typeof barrierOwner != 'object') {
        barrierOwner = {'name':barrierOwner, 'id':0}
      }
      return {"description": barrier.description, "strength": barrier.strength, "comment": barrier.comment,
        "type":barrier.type, "owner":barrierOwner}})


       return AXIOS.post('/potentialIncident/calculate/probability',
      {
        projectId: projectId,
        workType: workType,
        workOperation: workOperation,
        incidentType: incidentType,
        location:location,
        consequenceType: consequenceType,
        consequence: consequence,
        measures: [],
        consequenceAfterMeasures: consequenceAfterMeasures,
        barriers: barriers

      }
    ).then(response => response.data);
  },




  /** Customer methods **/
  getCustomers() {
    const url = '/customer';
    return AXIOS.get(url).then(response => response.data);
  },

  getCustomer (customerId) {
    const url = "/customer/";
    return AXIOS.get(url+ customerId).then(response => response.data);
  },
  createCustomer (name, logicalName, availableLanguages, riskMatrixType) {
    return AXIOS.post('/customer/' ,
      {
       name: name,
        logicalName: logicalName,
        availableLanguages: availableLanguages,
        riskMatrixType: riskMatrixType
      }
    ).then(response=>response.data)
  },
  editCustomer (id, name, logicalName, availableLanguages, active, riskMatrixType) {
    if (availableLanguages.length > 0 && typeof availableLanguages[0] == 'object') {
      availableLanguages = availableLanguages.map(lang=>{return lang.locale})
    }
    return AXIOS.patch('/customer/' ,
      {
        id: id,
        name: name,
        logicalName: logicalName,
        availableLanguages: availableLanguages,
        active:active,
        riskMatrixType: riskMatrixType
      }
    ).then(response=>response.data)
  },
  gotoCustomer (id) {
    return AXIOS.get('/customer/goto/' + id).then(response => response.data);

  },
  deleteCustomer (id) {
    return AXIOS.delete('/customer/' ,
      {
        data: {
          id: id}
      }
    ).then(response=>response.data)
  },


  setCurrentCustomer() {
    return AXIOS.get('/customer/current/info').then(response => response.data);

  },

  getUserInformation() {
    return AXIOS.get('/user/current/userInformation').then(response => response.data);
  },

  isUserNameUnique(username) {
  return AXIOS.get('/user/username/unique/' + username).then(response => response.data);

  },

  downloadRiskAnalysis (projectId, selectedWorkTypes, selectedWorkOperations, selectedLocations, selectedIncidentTypes, selectedColumns, barrierColumns, measureColumns, callback) {
    const FileDownload = require('js-file-download');
    AXIOS.post('/projectRiskAnalysis', {
      projectId:projectId,
      selectedWorkTypes:selectedWorkTypes,
      selectedWorkOperations: selectedWorkOperations,
        selectedLocations:selectedLocations,
      selectedIncidentTypes:selectedIncidentTypes,
        locale: store.state.curLanguage,
      columns: selectedColumns,
      barrierColumns: barrierColumns,
      measureColumns: measureColumns

    },
      {responseType: 'blob'})
      .then((response) => {
        FileDownload(response.data, 'riskSummary.xlsm');
        callback();
      })

  },

  downloadBarrierChecklist (projectId, selectedWorkTypes, selectedWorkOperations, selectedLocations, callback) {
    const FileDownload = require('js-file-download');
    AXIOS.post('/projectBarrierChecklist', {
        projectId:projectId,
        selectedWorkTypes:selectedWorkTypes,
        selectedWorkOperations: selectedWorkOperations,
        selectedLocations:selectedLocations,
        locale: store.state.curLanguage,
      },
      {responseType: 'blob'})
      .then((response) => {

        FileDownload(response.data, 'barrierChecklist.xlsx');
        callback();

      })

  },

  sendNewPassword(email) {
    return AXIOS.post('/user/resetPassword', {
      email: email,
      locale: store.state.curLanguage
    }).then(response =>response.data)
  },

  getConfig() {
    const url = '/config';
    return AXIOS.get(url).then(response => response.data);
  },

  /** AUthentication methods **/
  login(credentials) {
    const url = '/login';
    return AXIOS.post(url, credentials).then(response => response);
  },
  logout() {
    const url = '/logout';
    return AXIOS.post(url).then(response => response);

  },

  configureProxy() {
  }
}
